// extracted by mini-css-extract-plugin
module.exports = {"tagContainer":"styles_tagContainer__G2ztI"};